






























































































import { snakeCase } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Prop, VModel, Watch } from 'vue-property-decorator'

import { errorNotificationWrapper } from '../../../../../logic/helpers/NotificationService'
import Accordion from '../../../../Accordion/Accordion.vue'
import { UserProfile } from '../../../../BotUsers/components/Users/types'
import EmptyData from '../../../../EmptyData/EmptyData.vue'
import { SelectOptionData } from '../../../../Pi/types'

@Component({
  data() {
    return {
      isMobile,
      snakeCase,
    }
  },
  components: {
    EmptyData,
    Accordion,
  }
})
export default class ProfileFreeLabelsList extends Vue {
  @VModel() profile!: UserProfile

  @Prop() labels!: { [key: number]: string }

  @Prop() addLabel!: (user_id: number, label_id: number) => Promise<{ labels: { [key: number]: string }, user_id: number }>

  @Prop() removeLabel!: (user_id: number, label_id: number) => Promise<{ labels: { [key: number]: string }, user_id: number }>

  @Prop() createLabel!: (name: string) => Promise<{ index: number }>

  labelsIsOpen = false

  propertiesIsOpen = false

  newLabelName = ''

  popoverIsOpen = false

  @Watch('popoverIsOpen')
  popoverIsOpenWatcher(val: boolean): void {
    if (!val) {
      this.newLabelName = ''
    }
  }

  @Watch('labelsIsOpen')
  labelsWatcher(val: boolean): void {
    if (val) {
      this.propertiesIsOpen = false
    }
  }

  @Watch('propertiesIsOpen')
  propertiesWatcher(val: boolean): void {
    if (val) {
      this.labelsIsOpen = false
    }
  }

  createLabelHandler(): void {
    this.createLabel(this.newLabelName)
      .then(({ index }) => this.labels[index] = this.newLabelName)
      .finally(() => this.newLabelName = '')
      .catch((e) => errorNotificationWrapper(this.$t('error').toString(), e))
  }

  getFreeLabels(): Array<SelectOptionData> {
    const basy = Object.keys(this.profile.labels)

    return Object.entries(this.labels)
      .filter(([ id, name ]) => !basy.includes(id))
      .map(([ id, name ]) => {
        return {
          label: name,
          value: Number(id)
        }
      })
  }

  getLabels(): Array<SelectOptionData> {
    return Object.entries(this.profile.labels).map(([ id, name ]) => {
      return {
        label: name,
        value: id,
      }
    })
  }

  addLabelHandler(id: number): void {
    this.addLabel(this.profile.user_id, id).then(({ labels }) => this.profile.labels = labels)
  }

  removeLabelHandler(id: number): void {
    this.removeLabel(this.profile.user_id, id).then(({ labels }) => this.profile.labels = labels)
  }
}
